<template>
  <div>
    <div v-if="loading" class="text-center">
      <Loading></Loading>
    </div>

    <v-container v-else class="Kanit">
      <div class="text-center mt-4 mb-4">
        <h2 v-if="query.status" style="color: #0c4d9d">{{ query.status }}</h2>
        <h2 v-else style="color: #0c4d9d">หน้าจัดการคำสั่งซื้อ</h2>
      </div>
      <div>
        <div class="px-6">
          <v-card
            @click="showDialogData(item)"
            v-for="(item, k) in filteredData"
            :key="k"
            outlined
            class="mb-3 py-1"
          >
            <v-card-text style="line-height: 20px">
              <div style="font-weight: 900; color: black">
                Order : #{{ item.order_number }} ลูกค้า {{ item.customer_name }}
              </div>
              <div style="font-weight: bold; font-size: small; color: #0c4d9d">
                สถานะคำสั่งซื้อ :
                <span
                  :style="`font-weight: normal; font-style: italic; color: ${statusColor(
                    item.status
                  )};`"
                  >{{ item.status }}</span
                >
              </div>
            </v-card-text>
          </v-card>
        </div>
      </div>
    </v-container>
    <v-dialog fullscreen v-model="showDialog" width="650px">
      <v-card v-if="showDialog">
        <div class="text-right">
          <v-btn icon @click="showDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <!-- {{dialogdata.orderdetail.productlist}} -->
          <div class="Kanit mb-2">
            <div style="font-weight: 900; color: black">
              Order : #{{ dialogdata.order_number }}
            </div>
            <div style="font-weight: bold; font-size: small; color: #0c4d9d">
              สถานะคำสั่งซื้อ :
              <span
                :style="`font-weight: normal; font-style: italic; color: ${statusColor(
                  dialogdata.status
                )};`"
                >{{ dialogdata.status }}</span
              >
            </div>
            <div>ชื่อ : {{ dialogdata.customer_name }}</div>
            <div>ที่อยู่ : {{ dialogdata.customer_address }}</div>
            <div>
              Tracking no. :
              {{ dialogdata.trackingno ? dialogdata.trackingno : "-" }}
            </div>
            <div>การขนส่ง : {{ dialogdata.orderdetail.shippingtype }}</div>
            <div>ราคาค่าส่ง : {{ dialogdata.orderdetail.shippingcharge }}</div>
            <div class="mb-2" style="font-weight: bold">
              ราคารวม : {{ dialogdata.orderdetail.total }}
            </div>
            <a
              @click="goToOrderView"
              v-if="dialogdata.status == 'รอการจัดส่ง'"
              style="font-weight: bold"
              >ไปหน้าสรุปคำสั่งซื้อ</a
            >
          </div>
          <v-card
            outline
            class="mb-2 pa-1 Kanit"
            outlined
            v-for="item in dialogdata.orderdetail.productlist"
            :key="item.id"
          >
            <v-row>
              <v-col cols="5">
                <div v-if="item.image">
                  <v-img
                    lazy-src="../assets/whiteimg.jpg"
                    :src="item.image"
                    @error="() => (item.image = null)"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </div>
                <div v-else>
                  <div
                    style="
                      height: 100px;
                      width: 100px;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    <v-icon>mdi-block-helper</v-icon>
                  </div>
                </div>
              </v-col>
              <v-col class="pl-0" cols="7">
                <div style="font-weight: bold; font-size: 13px">
                  {{ item.sales_text_th }}
                </div>
                <div style="padding-right: 13px; font-size: 11px">
                  ขนาด: {{ item.size }} สี: {{ item.shade }}
                  {{ item.film_type ? `ฟิล์ม: ` + item.film_type : "" }}
                </div>
                <div
                  style="
                    padding-right: 13px;
                    font-weight: bold;
                    font-size: 13px;
                  "
                >
                  จำนวน: {{ item.quantity }}
                </div>
                <div style="font-size: 35px"></div>
                <div v-if="item.price" style="color: red">
                  ราคารวม:
                  {{ parseFloat(item.quantity) * parseFloat(item.price) }}
                </div>
                <div v-else style="color: red">ราคารวม: 0</div>
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "@/components/Loading.vue";
export default {
  components: {
    Loading,
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
    filteredData() {
      if (this.query.status) {
        return this.data.filter((el) => el.status == this.query.status);
      } else return this.data;
    },
  },
  data() {
    return {
      dialogdata: {},
      showDialog: false,
      data: [],
      loading: false,
    };
  },
  async mounted() {
    var vm = this;
    vm.loading = true;
    await this.getData();
    if (this.query.order_number && this.data && this.data.length) {
      var item = this.data.find(
        (el) => el.order_number == this.query.order_number
      );
      vm.showDialogData(item);
      this.showDialog = true;
    }
    vm.loading = false;
  },
  methods: {
    goToOrderView() {
      this.query.customerid = this.dialogdata.customerid;
      this.query.order_number = this.dialogdata.order_number;
      this.query.view = "OrderSummary";
    },
    statusColor(status) {
      if (status == "จัดส่งเรียบร้อย") return "green";
      else if (status == "รอการจัดส่ง") return "orange";
      else return "red";
    },
    showDialogData(item) {
      this.dialogdata = { ...item };
      this.dialogdata.orderdetail = JSON.parse(this.dialogdata.orderdetail);
      this.showDialog = true;
    },
    getData() {
      var vm = this;
      return new Promise((resolve) => {
        axios
          .get(
            "https://communitybotbyzwizai.herokuapp.com/toadealerordersmanagement",
            {
              params: {
                userid: this.$store.state.userid,
                apptype: this.query.apptype,
                pageid: vm.query.pageid,
              },
              headers: {
                AUTHORIZATION: "Bearer xxx xxx",
              },
            }
          )
          .then(async (response) => {
            if (response.data && response.data.responsecode == 400) {
              await vm.$swal.fire({
                icon: "error",
                text: response.data.reason,
              });
              resolve();
            } else if (response.data.responsecode == 200) {
              vm.data = response.data.data;
              resolve();
            }
          });
      });
    },
  },
};
</script>
